import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, DocumentSnapshot, DocumentData } from 'firebase/firestore'

export default class Projects extends BaseModel {
  constructor() {
    super(collection(db, 'projects'))
  }

  normalize(snapshotArray: DocumentSnapshot[]): (DocumentData | undefined)[] {
    const da: (DocumentData | undefined)[] = snapshotArray.map((r) => this.fromDatabase(r))
    return da
  }

  denormalize(project: DocumentData): DocumentData {
    return this.toDatabase(project)
  }

  fromDatabase(snapshot: DocumentSnapshot): DocumentData | undefined {
    if (snapshot.exists()) {
      const project: DocumentData = snapshot.data() || {}

      const {
        intake: {sections},
      } = project

      for (let i in sections) {
        const section = sections[i]
        let fields: DocumentData = {}
        if (Array.isArray(section.fields)) {
          for (let field of section.fields) {
            fields[field.id] = field
          }
          section.fields = fields
        }
      }

      return project
    }
  }

  toDatabase(project: DocumentData): DocumentData {
    const {sections} = project.intake || {}
    if (!sections) return project

    for (let i in sections) {
      const section = sections[i]
      section.fields = Object.values(section.fields || {})
    }
    return project
  }
}
